/**
 * Render a named slot, or fall back.
 *
 * Vue 3 merged `$slots` into `$slots` and made every slot a function, so the two-collection
 * distinction Vue 2 had is gone -- `$slots[name]` is now always callable when the slot was passed.
 * No `?.` on `$slots`: every caller passes a component instance, and an instance always has one.
 */
export function slot (vm: any, slotName: any, otherwise?: any) {
  return vm.$slots[slotName] !== void 0
    ? vm.$slots[slotName]()
    : otherwise
}
